import {AboutPackage} from './components/about/AboutPackage'
import './scss/topbar.scss'

const TopbarPackage = {
    name: 'topbar',
    configure(configurator) {
        configurator.import(AboutPackage)
    }
}

export {TopbarPackage}
